module.exports = __webpack_public_path__ + "img/dcopslogo.2693accb.png";